import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { deleteSystemRole } from "../functions";

const CategoriesTypeDelete = ({openDelete,setOpenDelete}) => {
    const { systemRoleIdSelected } = useSelector(({ systemRole }) => systemRole);
    const deleteFnc = async () =>{
    await deleteSystemRole(systemRoleIdSelected);
    setOpenDelete(false);
}
    return (
        <>
            <Dialog
            open={openDelete}
            onClose={()=>setOpenDelete(false)}
            >
                <DialogTitle>
                    <Typography variant="title">{"Eliminar"}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="subtitle">
                        {"Continuar con la Eliminación del Rol"}
                    </Typography>

                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={()=>setOpenDelete(false)} color="primary"
                    >
                        Cancelar
                    </Button>
                    <Button onClick={deleteFnc} color="primary"
                    >
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default CategoriesTypeDelete;